/* eslint-disable no-template-curly-in-string */
// disabling eslint rule since lodash templates provide a clean way of interpolated string mappings
import { template } from 'lodash';

interface TemplateData {
  [key: string]: string | undefined | null;
}
const DMS_ERROR_CODES_MAP: {
  [key: string]: string;
} = {
  DMS_DNF:
    'Error pulling ${ dmsType } deal ${ dmsDealId }. You can proceed by modifying the fields below to match the final DMS numbers. Please contact support for additional help.',
};

/**
 * Display a pretty error message based on dmsErrorCode if provided in the error object.
 * Checks specifically for DMS related error codes.
 * @param errObject
 * @param defaultMessage
 * @param templateData
 */
export const parseDMSError = (
  errObject: any,
  defaultMessage: string,
  templateData: TemplateData,
): string => {
  try {
    const parsedError = JSON.parse(errObject.error);

    if (parsedError?.dmsErrorCode) {
      const compile = template(
        DMS_ERROR_CODES_MAP[parsedError.dmsErrorCode] || defaultMessage,
      );

      // apply template vars across messages
      return compile(templateData);
    }
  } catch (e) {
    return defaultMessage;
  }
  return defaultMessage;
};
